import './style/index.less';
import LogoPageLayout from './LogoPageLayout';

export default LogoPageLayout;
